import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import type { NoteDraft } from "../components/studio/InlineNoteForm";

/**
 * P03: «＋ заметка к цели» — in Studio a quest objective can get a note that
 * lives at that objective. The Studio surface provides the action; the table's
 * views (no provider) show no such button.
 */
export interface QuestObjectiveNotes {
  /** «Готово» of the note form under the objective: the note is made from what was typed. */
  readonly addNote: (questId: string, objectiveId: string, draft: NoteDraft) => void;
  /** The notes that live at this objective, as cards under it (mockup quests__beat); null when none. */
  readonly renderNotes?: (questId: string, objectiveId: string) => ReactNode;
}

export const QuestObjectiveNotesContext = createContext<QuestObjectiveNotes | null>(null);

export function useQuestObjectiveNotes(): QuestObjectiveNotes | null {
  return useContext(QuestObjectiveNotesContext);
}
